import React from "react";
import styles from "./textComponents.module.css"; // Combined CSS Module

export function Heading({ children, color = "#000" }) {
  return (
    <h1 className={styles.heading} style={{ color }}>
      {children}
    </h1>
  );
}

export function Paragraph({ children, color = "#000" }) {
  return <p className={styles.paragraph} style={{color}}>{children}</p>;
}
